// Public pages must not inherit the CMS session's selected organization.
// Fetch can omit cookies for same-origin requests; XMLHttpRequest cannot.
export const publicGet = async url => {
  const response = await fetch(url, {
    credentials: "omit",
    headers: { Accept: "application/json" },
  });
  if (!response.ok) throw new Error(`Public request failed (${response.status})`);
  return { data: await response.json() };
};
